import React from 'react';
import Select from 'react-select';
import { Form } from 'react-bootstrap';
import { ErrorMessage } from 'formik';
import PropTypes from 'prop-types';
import '../../assets/styles/react-select.scss';

const MultiSelectItemDropdown = ({
  id,
  labelText,
  name,
  fromArray,
  formProps,
  isDisabled,
  innerRef,
  isAllItemOption,
  isAllItemValuesWithNoArray = false,
  isRequiredField = false,
  showErrorMessage = false,
  onChangeAction,
  menuPlacement = 'auto',
}) => {
  const OptionForAll = {
    value: 'all',
    label: 'Select All',
  };

  // Select option items
  const options = fromArray.map((item) => ({
    value: item.value,
    label: item.label,
  }));
  if (isAllItemOption) {
    options.unshift(OptionForAll);
  }

  const allItemsList =
    fromArray && fromArray.length > 0 && fromArray.map((mItem) => mItem.value);

  return (
    <Form.Group controlId={id}>
      <Form.Label>
        {labelText} {isRequiredField && <span className="text-danger">*</span>}
      </Form.Label>
      <Select
        ref={innerRef}
        name={name}
        options={options}
        isMulti
        isClearable
        className="basic-multi-select"
        classNamePrefix="select"
        isDisabled={isDisabled}
        isSearchable
        menuPlacement={menuPlacement}
        onChange={(sOptions) => {
          if (
            sOptions.length &&
            sOptions.find((sOption) => sOption.value === 'all')
          ) {
            if (isAllItemValuesWithNoArray) {
              formProps.setFieldValue(name, 'all');
            } else {
              formProps.setFieldValue(name, [...allItemsList]);
            }
          } else {
            formProps.setFieldValue(
              name,
              sOptions.map((item) => item.value)
            );
          }
          if (onChangeAction) {
            onChangeAction(sOptions.map((item) => item.value));
          }
        }}
        theme={(theme) => ({
          ...theme,
          colors: {
            ...theme.colors,
            primary: '#0649b5',
            neutral10: '#edf2f9',
            neutral20: '#d2ddec',
            neutral30: '#d2ddec',
            neutral50: '#b1c2da',
            neutral80: '#12263f',
            dangerLight: '#DEEBFF',
            danger: '#12263f',
          },
        })}
      />
      {showErrorMessage && (
        <ErrorMessage
          name={name}
          render={(msg) => <small className="text-danger">{msg}</small>}
        />
      )}
    </Form.Group>
  );
};

MultiSelectItemDropdown.propTypes = {
  id: PropTypes.string,
  fromArray: PropTypes.array,
  name: PropTypes.string,
  labelText: PropTypes.string,
  formProps: PropTypes.any,
  isDisabled: PropTypes.bool,
  isAllItemOption: PropTypes.bool,
  isAllItemValuesWithNoArray: PropTypes.bool,
  innerRef: PropTypes.any,
  isRequiredField: PropTypes.bool,
  showErrorMessage: PropTypes.bool,
  onChangeAction: PropTypes.func,
  menuPlacement: PropTypes.string,
};

export default MultiSelectItemDropdown;
